import { ColDef, ICellRendererParams } from 'ag-grid-community';

export const FFLSearchColumnDef: ColDef[] = [
    {
      // ID
      headerName: ' ID',
      field: 'id',
      resizable: true,
      width: 135,
      filter: 'agTextColumnFilter',
      hide: true
    },
    {
      // FFL ID
      headerName: 'FFL',
      field: 'ffl',
      resizable: true,
      width: 190,
      filter: 'agTextColumnFilter',
      //hide: true
    },
    {
      // FFL Legal Name
      headerName: 'FFL Legal Name',
      field: 'legal_name',
      resizable: true,
      width: 275,
      tooltipField: 'ffl_legal_name',
      filter: 'agTextColumnFilter',
    },
    {
      // FFL Business Name
      headerName: 'FFL Business Name',
      field: 'business_name',
      resizable: true,
      width: 275,
      tooltipField: 'ffl_business_name',
      filter: 'agTextColumnFilter',
    },
    {
      // FFL Expiration Date
      headerName: 'FFL Expiration Date',
      field: 'expiration_date',
      cellRenderer: expirationDateCellRenderer,
      resizable: true,
      width: 175,
      tooltipField: 'ffl_expiration_date',
      filter: 'agTextColumnFilter',
    },
       {
      // Attachment
      headerName: 'Attachment',
      field: 'certified_ffl_blob_name',
      resizable: true,
      width: 120,
      filter: false,
      sortable: false,
      cellRenderer: (params: any) => {
        if (params.value) {
          return `<div class="d-flex justify-content-center align-items-center w-100 h-100"><i class="fa-solid fa-paperclip" style="cursor: pointer; color: #2399e5; font-size: 1.2em;"></i></div>`;
        }
        return '';
      },
      onCellClicked: (params: any) => {
        if (params.value && params.context.FflSearchComponent) {
          params.context.FflSearchComponent.viewAttachment(params.event, params.data.id);
        }
      }
    },
    {
      // Phone Number
      headerName: 'Phone Number',
      field: 'phone_number',
      resizable: true,
      width: 150,
      tooltipField: 'phone_number',
      filter: 'agTextColumnFilter',
      hide: false
    },
    {
      // Email
      headerName: 'Email',
      field: 'email',
      resizable: true,
      flex: 1,
      tooltipField: 'email',
      filter: 'agTextColumnFilter',
      hide: false
    },
    {
      // Notes
      headerName: 'Notes',
      field: 'notes',
      resizable: true,
      minWidth: 300,
      width: 125,
      tooltipField: 'notes',
      filter: 'agTextColumnFilter',
      flex: 1,
      hide: true,
    }
  ];

  function expirationDateCellRenderer(params: ICellRendererParams) {
    const expirationDate = new Date(params.value);
    const today = new Date();
  
    const color = expirationDate < today ? 'indianred' : 'white';
  
    return `<span style="color: ${color}; font-weight: bold">${params.value}</span>`;
  }